'use client';

import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { PAGE_TYPE } from '@/app/common/pageType.ts';
import type { SearchParams } from '@/server/searchParams.ts';

export const createSearchParamsFromUrl = (): SearchParams => {
  const searchParams = getSearchParams();

  // Coming from an hotel-details deeplink the dateFrom and dateTo are not in the URL but can be extracted from departureIntervals
  if (
    (searchParams[URLParameters.DATE_TO] === undefined || searchParams[URLParameters.DATE_FROM] === undefined) &&
    searchParams[URLParameters.TRIP_DATES]
  ) {
    const [dateFrom, dateTo] = searchParams[URLParameters.TRIP_DATES].split('-');
    searchParams[URLParameters.DATE_FROM] = dateFrom.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
    searchParams[URLParameters.DATE_TO] = dateTo.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  } else {
    delete searchParams[URLParameters.TRIP_DATES];
  }

  return { [URLParameters.PAGE_TYPE]: PAGE_TYPE.SEARCH, ...searchParams };
};
